import { IonIcon } from '@ionic/react'
import { arrowDown, arrowUp } from 'ionicons/icons'
import React from 'react'

interface Props {
	title: string
	className?: string
	currentData: number
	comparisonData: number
	activeView?: string
	unit?: string
}

const OverviewComparisonCard: React.FC<Props> = ({
	title,
	className,
	currentData,
	comparisonData,
	unit,
	activeView,
}) => {
	const comparisonIsHigher = currentData < comparisonData
	const isProductionView = activeView === 'production'

	return (
		<div className={`${className} overview-comparison-card`}>
			<span className='title text-text-grey-200 dark:text-text-grey-100'>{title}</span>

			<div className='title-value'>
				{isProductionView ? (
					comparisonIsHigher ? (
						<IonIcon className='text-highlight' icon={arrowDown} />
					) : (
						<IonIcon className='text-brand-primary-100-light' icon={arrowUp} />
					)
				) : comparisonIsHigher ? (
					<IonIcon className='text-brand-primary-100-light' icon={arrowDown} />
				) : (
					<IonIcon className='text-highlight' icon={arrowUp} />
				)}
				<div className='data text-text-dark dark:text-text-light font-medium'>
					{currentData.toFixed(2).toString().replace('.', ',')}
					<span className='unit'>{unit ?? '€'}</span>
				</div>
			</div>
		</div>
	)
}
export default OverviewComparisonCard
